/**
 * Routing helpers for padel assessment completions, the padel twin of
 * `JourneyAssessment/duprAppDone.ts`.
 *
 * A run's sport is decided by its journey collection prefix, which is why padel
 * has its own `padel_assessment_*` family rather than sharing the DUPR one:
 * collections are unique per (collection, sport), so sharing would resolve, but
 * both done-screen redirects key off the prefix and a shared prefix would send
 * padel completions to the DUPR "Thank you" screen.
 */

/** Prefix on the padel assessment journey collections. */
const PADEL_ASSESSMENT_COLLECTION_PREFIX = "padel_assessment_";

/**
 * Whether a journey collection belongs to a padel assessment.
 *
 * The prefix rather than the two current values, matching how
 * `isDuprAppCollection` is written: a collection retired later still routes to
 * the right done screen for the runs already stored under it.
 */
export function isPadelAssessmentCollection(
    collection: string | null | undefined,
): boolean {
    return (collection ?? "").startsWith(PADEL_ASSESSMENT_COLLECTION_PREFIX);
}

/** Route for the padel assessment start screen. */
export const PADEL_ASSESSMENT_START_URL = "/journeys/padel-assessment";

/** Route for the padel assessment completion ("Thank you") screen. */
export function padelAppDoneUrl(ulid: string): string {
    return `${PADEL_ASSESSMENT_START_URL}/${ulid}/done`;
}
